import { render, staticRenderFns } from "./DocumentsForm.vue?vue&type=template&id=76f38b39&scoped=true"
import script from "./DocumentsForm.vue?vue&type=script&lang=js"
export * from "./DocumentsForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentsForm.vue?vue&type=style&index=0&id=76f38b39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f38b39",
  null
  
)

export default component.exports